import { type BonusEarnResource, Experiments } from "@/modules/experiments/src";
import { useExperiment } from "@/modules/experiments/src/hooks/useExperiment";
import { useIsEliteOrPremium } from "@/utilities/userTier";

/**
 * The bonus-earn offer config — a configurable Avion points multiplier from LD —
 * when it applies to this user (Elite/Premium tier + experiment on); undefined
 * otherwise. A non-null result means the user is eligible for the bonus.
 */
export const useBonusEarnResource = (): BonusEarnResource | undefined => {
  const isEliteOrPremium = useIsEliteOrPremium();
  const { getExperimentJsonPayload } = useExperiment();
  return isEliteOrPremium
    ? getExperimentJsonPayload<BonusEarnResource>(
        Experiments.STAYS_X_BONUS_POINTS_EARN.name
      )
    : undefined;
};
